export class Login {
        public email: string;
        public password: string;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Login.ts